<template>
	<div class="flex gap-2.5 items-center flex-wrap">
		<AppRadioCard
			v-for="option in options"
			:key="option.value"
			:label="option.label"
			:icon="option.icon"
			:active="selectedValue === option.value"
			:disabled
			@click="selectOption(option)"
		/>
	</div>
</template>

<script lang="ts" setup>
import { onMounted, watch } from "vue";

/**
 * Options to use for the select menu.
 * Value is what is given to v-model and should be unique.
 */
interface Option {
	label: string;
	icon?: string;
	value: string;
}

interface Props {
	options: Option[];
	allowNoneSelected?: boolean;
	disabled?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
	allowNoneSelected: false,
	disabled: false,
});
const selectedValue = defineModel<Option["value"] | undefined>(undefined);

function selectOption(option: Option) {
	if (option.value === selectedValue.value && props.allowNoneSelected) {
		selectedValue.value = undefined;
		return;
	}
	selectedValue.value = option.value;
}

/**
 * Forces a selection when `allowNoneSelected`.
 */
function forceSelection() {
	if (props.allowNoneSelected === false) {
		if (props.options.length < 1) {
			throw new Error("Could not init selection.");
		}
		const selectedOption = props.options.find(
			(option) => option.value === selectedValue.value,
		);
		if (selectedOption === undefined) {
			selectedValue.value = props.options[0]?.value;
		}
	}
}

onMounted(forceSelection);
watch(selectedValue, forceSelection);
</script>
